import { getAdaptiveCareLensKey } from './adaptiveQuickLogConfig';

const DEFAULT_MEDICATION_LOG_CONFIG = {
  title: "Today's medications",
  allDoneSubtitle: 'All doses logged - nice work',
  remainingSubtitle: (remainingCount) => `${remainingCount} dose${remainingCount === 1 ? '' : 's'} still due`,
  progressLabel: (takenCount, totalCount) => `${takenCount} of ${totalCount} doses logged`,
  progressRemainingLabel: (remainingCount) => (remainingCount > 0 ? `${remainingCount} remaining` : 'All doses logged for today'),
  completedStatusLabel: 'Completed',
  givenHeading: 'Given',
  plannedDoseLabel: 'Planned',
  givenDoseLabel: 'Given',
  pendingAsNeededLabel: 'As needed',
  pendingOverdueLabel: 'Overdue dose',
  pendingUpcomingLabel: 'Due later today',
  pendingDueNowLabel: 'Scheduled dose due now',
  primaryActionLabel: 'Mark as given',
  primaryActionLoadingLabel: 'Marking...',
  timeActionLabel: 'Log time',
  notePlaceholder: 'Any notes? (optional)',
  effectQuestionLabel: 'Did it help?',
  effectOptions: [
    { value: 'helped', label: 'Seemed to help' },
    { value: 'helped_a_little', label: 'Helped a little' },
    { value: 'no_change', label: 'No change noticed' },
    { value: 'too_soon', label: 'Too soon to tell' },
  ],
  confirmLabel: (dose) => `Confirm - ${dose ? `${dose} mg` : 'dose'}`,
  manageButtonLabel: 'Manage meds',
  backfillButtonLabel: 'Log past dose',
  emptyTitle: 'Nothing scheduled yet',
  emptyBody: "Add dosage times to your medications to build today's log.",
  toastDefault: 'Medication logged',
  loggedMessage: ({ medicationName, doseLabel, timeLabel }) => `Logged - ${medicationName} ${doseLabel} at ${timeLabel}`,
};

const MEDICATION_LOG_CONFIG_BY_LENS = {
  hospice: {
    ...DEFAULT_MEDICATION_LOG_CONFIG,
    title: 'Medications & Comfort',
    allDoneSubtitle: 'All comfort meds logged for today',
    remainingSubtitle: (remainingCount) => `${remainingCount} dose${remainingCount === 1 ? '' : 's'} still to review`,
    progressLabel: (takenCount, totalCount) => `${takenCount} of ${totalCount} doses logged`,
    progressRemainingLabel: (remainingCount) => (remainingCount > 0 ? `${remainingCount} still to review` : 'All comfort meds logged for today'),
    completedStatusLabel: 'Logged',
    givenHeading: 'Given',
    plannedDoseLabel: 'Plan',
    givenDoseLabel: 'Given',
    pendingAsNeededLabel: 'As needed for comfort',
    pendingOverdueLabel: 'Worth reviewing',
    pendingUpcomingLabel: 'Scheduled later today',
    pendingDueNowLabel: 'Scheduled dose due now',
    primaryActionLabel: 'Log as given',
    primaryActionLoadingLabel: 'Logging...',
    timeActionLabel: 'Add time / note',
    notePlaceholder: 'Any notes? (optional)',
    confirmLabel: (dose) => `Save comfort dose - ${dose ? `${dose} mg` : 'dose'}`,
    manageButtonLabel: 'Manage med plan',
    backfillButtonLabel: 'Log past dose',
    emptyTitle: 'No medication plan yet',
    emptyBody: 'Add scheduled or as-needed comfort meds to make logging faster.',
    toastDefault: 'Medication logged',
    loggedMessage: ({ medicationName, doseLabel, timeLabel }) => `Logged - ${medicationName} ${doseLabel} at ${timeLabel}`,
  },
};

export const getAdaptiveMedicationLogConfig = (child = {}) => (
  MEDICATION_LOG_CONFIG_BY_LENS[getAdaptiveCareLensKey(child)] || DEFAULT_MEDICATION_LOG_CONFIG
);
